import { getDataMapper, mapField, isPrimitive, isNil } from "@/shared";

export const mapDashboardFiltersToServer = getDataMapper({
    points: mapField("points"),
    period_interval: mapField("period", (period) => {
        return isPrimitive(period.interval) ? period.interval : null;
    }),
    period_from: mapField("period", (period) => {
        return isPrimitive(period.interval) || isNil(period.interval)
            ? null
            : period.interval.from;
    }),
    period_to: mapField("period", (period) => {
        return isPrimitive(period.interval) || isNil(period.interval)
            ? null
            : period.interval.to;
    }),
});
